import api from "../api";
import { User } from "../../models";
import { FailedToGetCurrentUserDataError } from "../../errors";

export const currentUserService = {
    getCurrentUser: async () => {
        try {
            const response = await api.me();
            const model: User = {
                displayName: response.displayName ?? "",
                principalName: response.principalName ?? "",
                photo: response.photo,
                permissions: {
                    canEditUrlMappings: response.permissions?.canManageReportUrlMappings ?? false,
                    canGenerateLogoutLinks: response.permissions?.canGenerateLogoutLinks ?? false
                }
            };
            return model;
        } catch (error) {
            throw new FailedToGetCurrentUserDataError();
        }
    }
};
